export const TRIAL_ENDING_COOKIE = "landinsight-trial-ending-dismissed";
export const IMPERSONATION_COOKIE = "impersonation";
